var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{ 'blue lighten-5': _vm.selected, 'green lighten-5': _vm.newReport },staticStyle:{"cursor":"pointer"},on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false},"click":function($event){_vm.detailDialog = true}}},_vm._l((_vm.headers),function(header,i){return _c('td',{key:i},[(
              typeof _vm.getObjectPath(header.value, _vm.report) =='string' && 
              (
                  header.value.indexOf('date') == -1 && 
                  header.value.indexOf('updated') == -1 && 
                  header.value.indexOf('created') == -1 
              )
          )?_c('span',[_vm._v(_vm._s(_vm.getObjectPath(header.value, _vm.report)|| "-"))]):_vm._e(),(
              typeof _vm.getObjectPath(header.value, _vm.report) =='string' && 
              (
                  header.value.indexOf('date') > -1 || 
                  header.value.indexOf('updated') > -1 || 
                  header.value.indexOf('created') > -1 
              )
              )?_c('span',[_vm._v(_vm._s(_vm.makeShortDate(_vm.getObjectPath(header.value, _vm.report))|| "-"))]):_vm._e(),(
              typeof _vm.getObjectPath(header.value, _vm.report) =='number' && 
              header.value.indexOf('Id') == -1 && 
              header.value.indexOf('id') == -1
          )?_c('span',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.displayDecimal(_vm.getObjectPath(header.value, _vm.report),2) || "-"))]):_vm._e(),(
              typeof _vm.getObjectPath(header.value, _vm.report) =='number' && 
              (
                  header.value.indexOf('Id') > -1 ||  
                  header.value.indexOf('id') > -1
              )
          )?_c('span',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.getObjectPath(header.value, _vm.report) || "-"))]):_vm._e()])}))}
var staticRenderFns = []

export { render, staticRenderFns }